import {
  FULL_TIME_PRODUCT_TYPE,
  PART_TIME_PRODUCT_TYPE,
  PRODUCT_TYPES,
  planDisplayName,
} from '../constants/productTypes';

export { FULL_TIME_PRODUCT_TYPE, PART_TIME_PRODUCT_TYPE };

export function planIncludesFormGeneration(productType) {
  const resolved = productType || FULL_TIME_PRODUCT_TYPE;
  const known = PRODUCT_TYPES.find((product) => product.value === resolved);
  if (known) return known.hasFormGeneration;
  return resolved !== PART_TIME_PRODUCT_TYPE;
}

export function nearestFormGenerationPlan({
  productType = null,
  plans = null,
  productDisplay = null,
} = {}) {
  const catalog = (plans || []).filter((plan) => (
    plan?.product_type && planIncludesFormGeneration(plan.product_type)
  ));
  const ranked = catalog.length
    ? [...catalog].sort((left, right) => (
      (left.monthly_fee_cents ?? Number.MAX_SAFE_INTEGER)
      - (right.monthly_fee_cents ?? Number.MAX_SAFE_INTEGER)
    ))
    : PRODUCT_TYPES
      .filter((product) => product.hasFormGeneration)
      .sort((left, right) => left.monthlyFeeCents - right.monthlyFeeCents)
      .map((product) => ({
        product_type: product.value,
        display_name: product.label,
        monthly_fee_cents: product.monthlyFeeCents,
      }));
  const upgrade = ranked.find((plan) => plan.product_type !== productType) || ranked[0] || null;
  return {
    currentPlanName: planDisplayName(productType, { productDisplay, plans })
      || planDisplayName(PART_TIME_PRODUCT_TYPE),
    upgradePlanName: upgrade?.display_name
      || planDisplayName(upgrade?.product_type)
      || planDisplayName(FULL_TIME_PRODUCT_TYPE),
  };
}

export function formGenerationUpgradeMessage({
  currentPlanName,
  upgradePlanName,
} = {}) {
  const current = currentPlanName || planDisplayName(PART_TIME_PRODUCT_TYPE);
  const upgrade = upgradePlanName || planDisplayName(FULL_TIME_PRODUCT_TYPE);
  return (
    `Form generation is not available with the ${current} plan. `
    + `Upgrade to ${upgrade} plan to enable Automated Form Generation and E-signatures`
  );
}

export function userCanGenerateForms({
  canGenerateForms,
  isSuperAdmin = false,
  isTransactionGuest = false,
  isPayingSubscriber = false,
  paymentUserType = null,
  productType = null,
} = {}) {
  if (typeof canGenerateForms === 'boolean') {
    return canGenerateForms;
  }
  if (isSuperAdmin) return true;
  if (isTransactionGuest) return false;
  const ptype = String(paymentUserType || '').toLowerCase();
  if (ptype === 'beta_tester' || ptype === 'free_trial') return true;
  const treatedAsSubscriber = ptype === 'subscriber' || (isPayingSubscriber && !ptype);
  if (!treatedAsSubscriber) return false;
  return planIncludesFormGeneration(productType);
}
